import { connect } from 'react-redux'
import * as action from '../../../state/overview/csv-upload/action'
import * as selector from '../../../state/overview/csv-upload/selector'
import FoilMetadataUpload from './FoilMetadataUpload'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        fetching: selector.selectIsFetching(state),
    }
}

const mapDispatchToProps = {
    uploadFoilCSV: action.uploadFoilCSV,
}


export default connect(mapStateToProps, mapDispatchToProps)(FoilMetadataUpload)



// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/csv-upload/FoilMetadataUploadContainer.js